// Loading.tsx
import "../../styles/loading.css";

const Loading = () => (
  <div className="loader">
    <label>A carregar...</label>
    <div className="loading"></div>
  </div>
);

export default Loading;
